import { getCentsSeparatorByCurrencyCode as R } from "./getCentsSeparatorByCurrencyCode.mjs";
import { getSeparatorByCurrencyCode as u } from "./getSeparatorByCurrencyCode.mjs";
import { CURRENCY_CODE_TO_SEPARATOR as E, CURRENCY_CODE_TO_CENTS_SEPARATOR as m } from "./moneyUtils.consts.mjs";
const r = Array.from(
  /* @__PURE__ */ new Set([...Object.values(E), ...Object.values(m)])
).join("").replace(".", "\\."), _ = (a, n) => {
  const e = String(a).replace(new RegExp(`[^${r}0-9-]`, "g"), "");
  if (!e)
    return "0";
  const c = u(n), p = R(n), t = e.split(new RegExp(`[${r}]`)), o = !!(e.includes(c) && e.includes(p)), s = t.length === 2, i = o || s ? t.slice(-1)[0] : "0", l = o || s ? t.slice(0, -1).join("") : t.join(""), g = String(l || "0").replace(new RegExp(`[${r}]`, "g"), ""), S = String(i || "0").replace(new RegExp(`[${r}]`, "g"), "");
  return `${g}.${S}`;
};
export {
  _ as stringToBigFormat
};
//# sourceMappingURL=stringToBigFormat.mjs.map
